import React from 'react';
import Icon from '../../../components/AppIcon';
import { useLanguage } from '../../../contexts/LanguageContext';

const FilterBar = ({ selectedRole, selectedIndustry, onRoleChange, onIndustryChange }) => {
  const { t } = useLanguage();
  
  const roles = [
    { value: 'all', label: t('preview.allRoles') },
    { value: 'ceo', label: 'CEO' },
    { value: 'cfo', label: 'CFO' },
    { value: 'cto', label: 'CTO' },
    { value: 'coo', label: 'COO' },
    { value: 'cmo', label: 'CMO' },
    { value: 'cpo', label: 'CPO' },
  ];

  const industries = [
    { value: 'all', label: t('preview.allIndustries') },
    { value: 'technology', label: 'Technology' },
    { value: 'finance', label: 'Finance' },
    { value: 'saas', label: 'SaaS' },
    { value: 'ecommerce', label: 'E-commerce' },
    { value: 'marketing', label: 'Marketing' },
    { value: 'construction', label: 'Construction' },
    { value: 'immobilier', label: 'Real Estate' },
  ];

  return (
    <div className="bg-white/40 backdrop-blur-xl border border-white/20 rounded-2xl p-4 shadow-lg">
      <div className="flex flex-col md:flex-row gap-4">
        {/* Role Filter */}
        <div className="flex-1">
          <label className="flex items-center gap-2 text-sm font-semibold text-[#6B7280] mb-2">
            <Icon name="Briefcase" size={16} color="#6B7280" />
            {t('preview.filterByRole')}
          </label>
          <div className="flex flex-wrap gap-2">
            {roles?.map((role) => (
              <button
                key={role?.value}
                onClick={() => onRoleChange(role?.value)}
                className={`px-4 py-2 text-sm font-medium rounded-lg transition-all duration-200 ${
                  selectedRole === role?.value
                    ? 'bg-[#0025cc] text-white shadow-md'
                    : 'bg-white/60 text-[#6B7280] hover:bg-white/80 border border-[#E5E7EB]'
                }`}
              >
                {role?.label}
              </button>
            ))}
          </div>
        </div>

        {/* Industry Filter */}
        <div className="flex-1">
          <label className="flex items-center gap-2 text-sm font-semibold text-[#6B7280] mb-2">
            <Icon name="Building2" size={16} color="#6B7280" />
            {t('preview.filterByIndustry')}
          </label>
          <div className="flex flex-wrap gap-2">
            {industries?.map((industry) => (
              <button
                key={industry?.value}
                onClick={() => onIndustryChange(industry?.value)}
                className={`px-4 py-2 text-sm font-medium rounded-lg transition-all duration-200 ${
                  selectedIndustry === industry?.value
                    ? 'bg-[#0025cc] text-white shadow-md'
                    : 'bg-white/60 text-[#6B7280] hover:bg-white/80 border border-[#E5E7EB]'
                }`}
              >
                {industry?.label}
              </button>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default FilterBar;